import React, { Component } from "react";
import cx from "classnames";
import moment from "moment";
import { register, unregister } from "@shared/core/globalClick";
import { StockCalendarLoader } from "./calendar/stock-calendar-loader";

const globalClickId = "d05f73cc137da9405d6429c113a0b9198131e8d0ec9b8e4b6a6793e26efbf1b5";

/**
 *
 * @param {moment} momentObject
 */
function validMomentObjectOrNull(momentObject) {
  return momentObject.isValid() ? momentObject : null;
}

export default class BookDates extends Component {
  static get defaultProps() {
    return {
      onChange() {},
      value: { checkin: null, checkout: null },
    };
  }

  constructor(props, context) {
    super(props, context);
    this.state = {
      focusedInput: null,
      calendarVisible: false,
    };
    this.handleDatesChange = this.handleDatesChange.bind(this);
    this.handleTableClick = this.handleTableClick.bind(this);
    this.renderCalendarInfo = this.renderCalendarInfo.bind(this);
  }

  componentDidMount() {
    register(this, globalClickId);
  }

  componentWillUnmount() {
    unregister(this, globalClickId);
  }

  onGlobalClick() {
    this.setState({ calendarVisible: false });
  }

  handleDatesChange({ startDate, endDate }) {
    let type = "ci";
    if (endDate && this.state.focusedInput === "endDate") {
      this.setState({ calendarVisible: false });
      type = "co";
    }
    this.props.onChange(
      {
        checkin: startDate && startDate._isAMomentObject ? startDate.format("YYYYMMDD") : startDate,
        checkout: endDate && endDate._isAMomentObject ? endDate.format("YYYYMMDD") : endDate,
      },
      type
    );
  }

  handleTableClick(e) {
    const target = e.currentTarget;
    this.setState({
      calendarVisible: true,
      focusedInput: target.getAttribute("data-focused-input"),
    });
  }

  renderDateCell({ mDate, label, calendarInputKey, availableTime }) {
    const noValue = !mDate;
    const { readOnly } = this.props;
    return (
      <div className="bookDatesTable__cell bookDatesCell">
        <div className="bookDatesCell__container">
          <div className="bookDatesCell__label">
            <span>{label}</span>
            {!availableTime || <span className="bookDatesCell__availableTime">{availableTime}</span>}
          </div>
          <div
            className={cx("zg-input", {
              "zg-input--focus": this.state.calendarVisible && calendarInputKey === this.state.focusedInput,
            })}
          >
            <button
              type="button"
              className={cx(`zg-input__input bookDatesCell__date bookDatesCell__date--${calendarInputKey}`, {
                "zg-input__input--placeholder": noValue,
              })}
              data-focused-input={calendarInputKey}
              disabled={readOnly}
              onClick={this.handleTableClick}
              title={`选择${label}`}
              aria-label={`选择${label}`}
            >
              {mDate ? mDate.format("MM月DD日") : "选择日期"}
            </button>
          </div>
        </div>
      </div>
    );
  }

  renderCalendarInfo() {
    return <div className="bookDatesCalendar__info">预订时长：{this.renderNightsRangeTip()}</div>;
  }

  renderNightsRangeTip() {
    const { minNights, maxNights } = this.props;
    return (
      <span className="nightsRangeTip">
        {!minNights || <span>至少{minNights}晚</span>}
        {!(maxNights > 0 && maxNights !== Infinity) || <span>至多{maxNights}晚</span>}
      </span>
    );
  }

  render() {
    const { value, minNights, maxNights, originalPrice, calendarDialog } = this.props;
    const { calendarVisible } = this.state;
    const { checkin, checkout } = value || {};
    const cicoTime = this.props.cicoTime || {};
    const mCheckin = checkin && validMomentObjectOrNull(moment(checkin, "YYYYMMDD"));
    const mCheckout = checkout && validMomentObjectOrNull(moment(checkout, "YYYYMMDD"));

    const DiaglogComponent = calendarDialog || "div";

    return (
      <div className="bookDates" ref={globalClickId}>
        <div className="bookDatesTable">
          {this.renderDateCell({
            mDate: mCheckin,
            label: "入住日期",
            calendarInputKey: "startDate",
            availableTime: cicoTime.checkin,
          })}
          {this.renderDateCell({
            mDate: mCheckout,
            label: "退房日期",
            calendarInputKey: "endDate",
            availableTime: cicoTime.checkout,
          })}
        </div>
        {!calendarVisible || (
          <DiaglogComponent className="bookDates__stockCalendar">
            <StockCalendarLoader
              productId={this.props.productId}
              startDate={mCheckin}
              endDate={mCheckout}
              focusedInput={this.state.focusedInput}
              onFocusChange={focusedInput => this.setState({ focusedInput })}
              onDatesChange={this.handleDatesChange}
              minimumNights={minNights}
              maximumNights={maxNights}
              daySize={50}
              originalPrice={originalPrice}
              renderCalendarInfo={this.renderCalendarInfo}
            />
          </DiaglogComponent>
        )}
      </div>
    );
  }
}

require("./book-dates.less");